import Pages from "pages";
import { ComponentClass, FunctionComponent } from "react";

export interface RoutesI {
  path: string;
  component: ComponentClass | FunctionComponent,
  fullWidth?: boolean
  protected?: boolean
}

export const routes: RoutesI[] = [
  { path: "/admin", component: Pages.Admin, fullWidth: true, protected: true },
  { path: "/admin/node-editor", component: Pages.NodeEditor, fullWidth: true, protected: true },
  { path: "/forgot-password", component: Pages.Auth.ForgotPassword },
  { path: "/login", component: Pages.Auth.Login },
  { path: "/reset-password", component: Pages.Auth.ResetPassword },
  { path: "/401", component: Pages.Auth.Unauthorized },
  { path: "/", component: Pages.Calculator },
];
